import { useCallback } from "react";
import { CouponsApi, useAPIAction } from "melco-shared-logic";
import { AddNewCouponFormValueType } from "../../components/coupons/form/AddNewCouponForm";

export const useAddNewCoupon = () => {
  const [AddNewCoupon] = useAPIAction(
    CouponsApi,
    async (api, newCouponDetails: AddNewCouponFormValueType) => {
      const data = await api.couponsCreate({
        controlcenterMelcoModelsCreateCoupon: {
          ...newCouponDetails,
          product_code_list: newCouponDetails?.product_code
        },
      });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "coupons.actions.add_new",
    }
  );

  return useCallback(
    async (NewCouponDetails: AddNewCouponFormValueType) => {
      try {
        await AddNewCoupon(NewCouponDetails);
      } catch (e) {
        return { success: false };
      }

      return { success: true };
    },
    [AddNewCoupon]
  );
};
